import { render, staticRenderFns } from "./create.vue?vue&type=template&id=982b73f0&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('982b73f0')) {
      api.createRecord('982b73f0', component.options)
    } else {
      api.reload('982b73f0', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=982b73f0&", function () {
      api.rerender('982b73f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/school/create.vue"
export default component.exports